import { render } from "./QuanLyKhoanLuong.vue?vue&type=template&id=f15a5faa&scoped=true"
import script from "./QuanLyKhoanLuong.vue?vue&type=script&lang=js"
export * from "./QuanLyKhoanLuong.vue?vue&type=script&lang=js"

import "./QuanLyKhoanLuong.vue?vue&type=style&index=0&id=f15a5faa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f15a5faa"]])

export default __exports__